import { render, staticRenderFns } from "./SectionTwo.vue?vue&type=template&id=48aa0122&scoped=true&"
import script from "./SectionTwo.vue?vue&type=script&lang=js&"
export * from "./SectionTwo.vue?vue&type=script&lang=js&"
import style0 from "./SectionTwo.vue?vue&type=style&index=0&id=48aa0122&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48aa0122",
  null
  
)

export default component.exports